export const API_CONSTANTS = Object.freeze({
  // !! Don't Delete This Comment !!
  // !! Don't Not Commit dev !!
  // !! This For Frontend call API !!
  // http://159.65.141.162/portalv2/
  // https://aliyunportal-dev.henkel.cn/portalv2/
  // BASE_API_URL: "http://159.65.141.162/portalv2/",
  BASE_API_URL: "https://aliyunportal-dev.henkel.cn/portalv2/",
  // BASE_API_URL: "/portalv2/",
  DATETIME_FROM_START_TIME: " 00:00:00.000",
  DATETIME_TO_END_TIME: " 23:59:59.999",
});
